<template> 
	<div class='info' :class="optionalClass">
	   	<slot name="icon" v-if="hasIcon">icon</slot>
	    <slot name="keyLabel">keyLabel</slot>
    </div>
</template>
<script>
	export default {
        name: 'conversationIconKey',
        props: ['hasIcon', 'optionalClass']
    }
</script>